import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useQnaQuestions } from "../../api/qnaApi";
import { useStudent } from "../../api/studentApi";
import Table from "../../components/Table";
import { QnaQuestionTableDef } from "../../table/QnaQuestionTableDef";
import { SingleFilter, useFilter } from "../../components/Filter";
import { getQnaFilterDict } from "../../filters/qnaFilter";
import { usePagination } from "../../components/Pagination";

const StudentForum = () => {
  const [filters, setFilters] = useState({});
  const { pagination, setPage } = usePagination();

  const { data: questions, isLoading: isQuestionsLoading } = useQnaQuestions({
    filters,
    pagination,
  });
  const { data: student, isLoading: isStudentLoading } = useStudent();

  const { valueDict, setValue, deleteKeyword } = useFilter();

  const maxPage = useMemo(() => {
    if (!questions) return 0;
    return Math.ceil(questions.total / 10);
  }, [questions]);

  if (isStudentLoading) return <p>로딩 중...</p>;
  return (
    <div className="wideContent">
      <div className="horizontal">
        <Link to="question">
          <button className="moveButton">등록하기</button>
        </Link>
      </div>
      <div className="search">
        <SingleFilter
          valueDict={valueDict}
          filterDict={getQnaFilterDict([student.student.department], "student")}
          setValue={setValue}
          deleteKeyword={deleteKeyword}
        />
        <button
          onClick={() => {
            setPage(0);
            setFilters(valueDict);
          }}
        >
          검색
        </button>
      </div>
      {isQuestionsLoading ? (
        <p>로딩 중...</p>
      ) : questions.questions.length ? (
        <Table
          columns={QnaQuestionTableDef}
          data={questions.questions}
          rowLink={(original) => original.id}
          paginationProps={{ page: pagination.page, setPage, maxPage }}
          columnPinning={{}}
        />
      ) : (
        <p>등록된 글이 없습니다. </p>
      )}
    </div>
  );
};

export default StudentForum;
